<script setup lang="ts">
import type { Stat } from '@collector/sportsapi-types'

import CommonStatisticInput from './CommonStatisticInput.vue'

export type Props = {
  dirty?: boolean
  disabled?: boolean
  size?: 'sm' | 'md'
  formatPercent?: boolean
}

withDefaults(defineProps<Props>(), { size: 'md' })

const stat = defineModel<Stat>({ required: true })
</script>

<template>
  <CommonStatisticInput
    v-model="stat"
    :dirty
    :disabled
    :size
    :formatSuffix="formatPercent ? '%' : ''"
    :maxlength="3"
    numeric
  />
</template>
